// @flow
import React from 'react';
import PropTypes from 'prop-types';
import UnauthorizedIcon from '../../assets/empty-state/no-approvals.svg';
import messages from '../../../data/approvals';

import './NoApprovals.scss';

type Props = {};

type Context = {
  intl: Object,
};

const NoApprovals = (props: Props, { intl }: Context) => (
  <div className="no-approvals-component">
    <div className="no-approvals-component__container">
      <div className="no-approvals-component__icon">
        <img alt="" src={UnauthorizedIcon} />
      </div>
      <div className="no-approvals-component__text-container">
        <div className="no-approvals-component__title">{intl.formatMessage(messages.noApprovalsTitle)}</div>
        <div className="no-approvals-component__text">{intl.formatMessage(messages.noApprovalsText)}</div>
      </div>
    </div>
  </div>
);

NoApprovals.displayName = 'NoApprovals';

NoApprovals.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default NoApprovals;
